<mat-progress-bar mode="indeterminate" *ngIf="loading && showBackButton"></mat-progress-bar>
<mat-spinner *ngIf="loading && !showBackButton"></mat-spinner>
<ng-container *ngIf="!loading">
    <ng-container *ngIf="isLocumsEmploymentType$ | async; else nonLocums">
        <nova-locums-recruiter-job-details [id]="job.id" [title]="job.jobTitle" [isOnHold]="job.isOnHold"
            [showBackButton]="showBackButton" [displayConfigData]="displayConfigData"></nova-locums-recruiter-job-details>
    </ng-container>
</ng-container>
<ng-template #nonLocums>
    <div class="job-detail-container" data-cy="jobDetailsPage">
        <nova-detail-toolbar [title]="'Job Details'" [showBackButton]="showBackButton"></nova-detail-toolbar>
        <mat-tab-group>
            <mat-tab label="JOB">
                <ng-container [ngTemplateOutlet]="jobDetailsTemplate"></ng-container>
            </mat-tab>
            <mat-tab label="LICENSURE" *ngIf="job && job.stateId">
                <nova-recruiting-state-details [itemId]="job.stateId"></nova-recruiting-state-details>
            </mat-tab>
        </mat-tab-group>
    </div>
</ng-template>

<ng-template #jobDetailsTemplate>
    <div class="main-container">
        <div *ngIf="job" class="nova-toolbar" style="min-height: 40px" flex>
            <span class="md-title" style="color: white !important">{{job.jobTitle}}</span>
        </div>

        <div class="app-accountmanagers-job-details-header-note-container" *ngIf="displayConfigData">
            <div class="app-dialog-note-container app-first-note-container">
                <div class="app-dialog-note-table">
                    <div class="app-dialog-note-row">
                        <div class="app-dialog-note-cell app-width-36px">
                            <div class="app-dialog-note-icon">
                                <mat-icon class="material-icons-outlined">info</mat-icon>
                            </div>
                        </div>
                        <div class="app-dialog-note-cell app-v-center">
                            <span class="app-dialog-note-text">This job displays differently on external sites such as
                                MyAya.
                                Differences are in parentheses below.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="app-job-details-header-note-container" *ngIf="job?.isOnHold">
            <div class="app-dialog-note-container app-first-note-container">
                <div class="app-dialog-note-table">
                    <div class="app-dialog-note-row">
                        <div class="app-dialog-note-cell app-width-36px">
                            <div class="app-dialog-note-icon">
                                <img src="assets/images/big_stop_sign.png" class="rating-img" title="Job on Hold"
                                    alt="job on hold" />
                            </div>
                        </div>
                        <div class="app-dialog-note-cell app-v-center">
                            <span class="app-dialog-note-text">This job is on hold (not accepting submittals)</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="app-job-details-header-note-container" *ngIf="job?.isAcceptingNewGrads"
            data-qa-id="recruiting-job-details-header-note-accepting-new-grads">
            <div class="app-dialog-note-container app-first-note-container">
                <div class="app-dialog-note-table">
                    <div class="app-dialog-note-row">
                        <div class="app-dialog-note-cell app-width-36px">
                            <div class="app-dialog-note-icon">
                                <img src="assets/images/svg/grad-cap-black.svg" title="This job accepts new graduates."
                                    alt="This job accepts new graduates." />
                            </div>
                        </div>
                        <div class="app-dialog-note-cell app-v-center">
                            <span class="app-dialog-note-text">This job accepts new graduates.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

        <div *ngIf="job" class="md-padding">
            <div class="flex-row">
                <div class="flex-column flex-50">
                    <mat-card>
                        <div>
                            <div class="row-margin col-item flex-row">
                                <strong class="nova__label flex-40">Updated:</strong>
                                <span class="flex-60" data-qa-id="an_rjd_updated_readonly">
                                    {{job.updatedDate | date : "M/d/yyyy" }}
                                </span>
                            </div>
                            <ng-container *ngIf="isLocumsEmploymentType$ | async">
                                <div class="row-margin col-item flex-row">
                                    <strong class="nova__label flex-40">Employment Type:</strong>
                                    <span class="flex-60" data-qa-id="an_rjd_employment_type_readonly">
                                        {{job.employmentTypeText}}
                                    </span>
                                </div>
                            </ng-container>
                            <div class="row-margin col-item flex-row">
                                <strong class="nova__label flex-40">Position:</strong>
                                <span class="flex-60" data-qa-id="an_rjd_profession_readonly">
                                    {{job.professionName}} - {{job.title}}
                                </span>
                            </div>
                            <div class="row-margin col-item flex-row" *ngIf="job.unitName">
                                <strong class="nova__label flex-40">Unit:</strong>
                                <span class="flex-60" data-qa-id="an_rjd_unit_readonly"
                                    *ngIf="job.unitFormLinked === 0">
                                    {{job.unitName}}
                                </span>
                                <span class="flex-60" data-qa-id="an_rjd_unit_readonly"
                                    *ngIf="job.unitFormLinked === 1">
                                    <a (click)="openUnitLink($event, job.unitFormId)"
                                        class="nova__link">{{job.unitName}}</a>
                                </span>
                            </div>
                            <div class="row-margin col-item flex-row">
                                <strong class="nova__label flex-40">Specialty:</strong>
                                <span class="flex-60" data-qa-id="an_rjd_specialty_readonly">
                                    {{job.specialtyName}}
                                </span>
                            </div>
                            <span>
                                <div class="row-margin col-item flex-row" *ngIf="job?.clinicalTrack">
                                    <strong class="nova__label flex-40">Clinical Track:</strong>
                                    <span class="flex-60" data-qa-id="an_rjd_specialty_readonly">
                                        {{job?.clinicalTrack?.clinicalTrackName}}
                                    </span>
                                </div>
                            </span>
                            <div *ngIf="job.recruiterBonus" class="row-margin col-item flex-row">
                                <strong class="nova__label flex-40">Bonus:</strong>
                                <span [ngSwitch]="job.recruiterBonus" class="flex-60"
                                    data-qa-id="an_rjd_recruiter_bonus_readonly">
                                    <span *ngSwitchCase="0"></span>
                                    <span *ngSwitchCase="50">
                                        <img src="assets/images/svg/recruiter-bonus/50.svg" alt="50"
                                            style="width: 30px" />
                                    </span>
                                    <span *ngSwitchCase="100">
                                        <img src="assets/images/svg/recruiter-bonus/100.svg" alt="100"
                                            style="width: 30px" />
                                    </span>
                                    <span *ngSwitchCase="150">
                                        <img src="assets/images/svg/recruiter-bonus/150.svg" alt="150"
                                            style="width: 30px" />
                                    </span>
                                    <span *ngSwitchCase="200">
                                        <img src="assets/images/svg/recruiter-bonus/200.svg" alt="200"
                                            style="width: 30px" />
                                    </span>
                                    <span *ngSwitchCase="250">
                                        <img src="assets/images/svg/recruiter-bonus/250.svg" alt="250"
                                            style="width: 30px" />
                                    </span>
                                    <span *ngSwitchCase="300">
                                        <img src="assets/images/svg/recruiter-bonus/300.svg" alt="300"
                                            style="width: 30px" />
                                    </span>
                                    <span *ngSwitchCase="350">
                                        <img src="assets/images/svg/recruiter-bonus/350.svg" alt="350"
                                            style="width: 30px" />
                                    </span>
                                    <span *ngSwitchCase="400">
                                        <img src="assets/images/svg/recruiter-bonus/400.svg" alt="400"
                                            style="width: 30px" />
                                    </span>
                                    <span *ngSwitchCase="450">
                                        <img src="assets/images/svg/recruiter-bonus/450.svg" alt="450"
                                            style="width: 30px" />
                                    </span>
                                    <span *ngSwitchCase="500">
                                        <img src="assets/images/svg/recruiter-bonus/500.svg" alt="500"
                                            style="width: 30px" />
                                    </span>
                                    <span *ngSwitchCase="550">
                                        <img src="assets/images/svg/recruiter-bonus/550.svg" alt="550"
                                            style="width: 30px" />
                                    </span>
                                    <span *ngSwitchCase="600">
                                        <img src="assets/images/svg/recruiter-bonus/600.svg" alt="600"
                                            style="width: 30px" />
                                    </span>
                                    <span *ngSwitchDefault>{{job.recruiterBonus | currency:'USD' }}</span>
                                </span>
                            </div>
                            <div class="row-margin col-item flex-row">
                                <strong class="nova__label flex-40">{{billRateLabel}}:</strong>
                                <span class="flex-60" data-qa-id="an_rjd_hourlybillrate_readonly">
                                    <img *ngIf="job.isMarginBooster" src="assets/images/currency_dollar_green.png"
                                        title="Margin booster" alt="bill rate" class="hourly-bill-rate-icon" />
                                    {{ job.blendedBillRate | currency
                                    }}{{payFormatPeriodSpecification}}
                                </span>
                                <span
                                    *ngIf="!job.hospitalTypeId && ((isLocumsEmploymentType$ | async) === false)"><ng-container
                                        *ngTemplateOutlet="externalPayInfo"></ng-container></span>
                            </div>
                            <ng-container *ngIf="isLocums1099Job$ | async">
                                <div class="row-margin">
                                    <strong class="nova__label flex-40">Overtime Bill Rate:</strong>
                                    <span class="flex-60 ml-2" data-qa-id="an_rjd_overtimehourlybillrate_readonly">
                                        <ng-container
                                            *ngIf="job.additionalBillRate?.overtimeHourlyRate && job.additionalBillRate?.overtimeHourlyRateFactor; else nullNa">
                                            {{ job.additionalBillRate?.overtimeHourlyRate | currency
                                            }}{{ payFormatPeriodSpecification }} ({{
                                            job.additionalBillRate?.overtimeHourlyRateFactor }})
                                        </ng-container>
                                    </span>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="isLocums1099Job$ | async">
                                <div class="row-margin">
                                    <strong class="nova__label flex-40">Holiday Bill Rate:</strong>
                                    <span class="flex-60" data-qa-id="an_rjd_holidayhourlybillrate_readonly">
                                        <ng-container
                                            *ngIf="job.additionalBillRate?.holidayHourlyBillRate && job.additionalBillRate?.holidayHourlyRateFactor; else nullNa">
                                            {{ job.additionalBillRate.holidayHourlyBillRate | currency
                                            }}{{ payFormatPeriodSpecification }} ({{
                                            job.additionalBillRate.holidayHourlyRateFactor }})
                                        </ng-container>
                                    </span>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="isLocums1099Job$ | async">
                                <div class="row-margin col-item flex-row">
                                    <div class="flex-col flex-20">
                                        <strong class="nova__label">Call Bill Rates:</strong>
                                    </div>
                                    <div class="flex-col">
                                        <div class="margin-call-rates">
                                            <span class="flex-60 row-container"
                                                data-qa-id="an_rjd_twentyfourhourlybillrate_readonly">
                                                24hr Call -
                                                <ng-container
                                                    *ngIf="job.additionalBillRate?.twentyFourHourCallBillRate; else nullNa">
                                                    {{ job.additionalBillRate?.twentyFourHourCallBillRate
                                                    | currency }}/day
                                                </ng-container>
                                            </span>
                                        </div>
                                        <div class="margin-call-rates">
                                            <span class="flex-60 row-container"
                                                data-qa-id="an_rjd_night_call_bill_rate_readonly">
                                                Night Call -
                                                <ng-container
                                                    *ngIf="job.additionalBillRate?.nightCallBillRate; else nullNa">
                                                    {{ job.additionalBillRate?.nightCallBillRate |
                                                    currency }}{{ nightCallBillRateTypeDisplay }}
                                                </ng-container>
                                            </span>
                                        </div>
                                        <div class="margin-call-rates">
                                            <span class="flex-60 row-container"
                                                data-qa-id="an_rjd_weekend_hourly_bill_rate_readonly">
                                                Weekend Call -
                                                <ng-container
                                                    *ngIf="job.additionalBillRate?.weekendHourlyBillRate; else nullNa">
                                                    {{ job.additionalBillRate?.weekendHourlyBillRate |
                                                    currency }}{{ weekendCallPeriodSpecification }}
                                                </ng-container>
                                            </span>
                                        </div>
                                        <div class="margin-call-rates">
                                            <span class="flex-60 row-container"
                                                data-qa-id="an_rjd_callback_hourly_bill_rate_readonly">
                                                Call Back -
                                                <ng-container
                                                    *ngIf="job.additionalBillRate?.callBackHourlyBillRate; else nullNa">
                                                    {{ job.additionalBillRate?.callBackHourlyBillRate |
                                                    currency }}{{ weekendCallPeriodSpecification }}
                                                </ng-container>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="row-margin col-item flex-row" *ngIf="job.hospitalTypeId === 1">
                                <strong class="nova__label flex-40">Hourly Pay Rate:</strong>
                                <span class="flex-60" data-qa-id="an_rjd_hourlypay_readonly"
                                    *ngIf="job.perDiemPayRate">{{ job.perDiemPayRate | currency }}</span>
                                <span class="flex-60" *ngIf="!job.perDiemPayRate">Sorry, no rates have been set up yet
                                    for this job</span>
                                <ng-container *ngTemplateOutlet="externalPayInfo"></ng-container>
                            </div>

                            <div class="row-margin col-item flex-row"
                                *ngIf="job.hospitalTypeId === 2 || isLocumsEmploymentType$.value">
                                <strong class="nova__label flex-40">{{ payRangeLabel }}:</strong>
                                <span class="flex-60"
                                    *ngIf="(job.weeklyPayLow && job.weeklyPayLow > 0 && job.weeklyPayLow !== job.weeklyPayHigh) || (job.weeklyPayLow === 0 && job.weeklyPayHigh === 0)">
                                    <ng-container
                                        *ngIf="job.weeklyPayHigh > 0 && (job.weeklyPayLow === job.weeklyPayHigh || job.weeklyPayLow === 0)">
                                        Up to {{ job.weeklyPayHigh | currency }}{{
                                        payRangePeriodSpecification }}
                                    </ng-container>
                                    <ng-container
                                        *ngIf="job.weeklyPayLow && job.weeklyPayLow > 0 && job.weeklyPayLow !== job.weeklyPayHigh">
                                        {{ job.weeklyPayLow | currency }}{{
                                        payRangePeriodSpecification }} to {{ job.weeklyPayHigh |
                                        currency }}{{ payRangePeriodSpecification }}
                                    </ng-container>
                                    <ng-container
                                        *ngIf="job.weeklyPayLow && job.weeklyPayLow > 0 && job.weeklyPayLow === job.weeklyPayHigh">
                                        {{ job.weeklyPayLow | currency }}{{
                                        payRangePeriodSpecification }}
                                    </ng-container>
                                    <span class="flex-60"
                                        *ngIf="job.weeklyPayHigh && job.weeklyPayHigh > 0 && job.altWeeklyPayHigh > 0 && !isLocumsEmploymentType$.value">{{
                                        job.shiftType }}</span>
                                    <ng-container *ngIf="!isLocumsEmploymentType$.value">
                                        <small>
                                            <a (click)="whatsThis = true;" [hidden]="whatsThis"
                                                href="javascript:void(0);">What's this?</a>
                                        </small>
                                    </ng-container>
                                </span>
                                <span class="flex-60" *ngIf="!job.weeklyPayHigh || job.weeklyPayHigh < 1">Contact
                                    AM</span>
                                <ng-container *ngTemplateOutlet="externalPayInfo"></ng-container>
                            </div>

                            <div class="row-margin col-item flex-row"
                                *ngIf="job.hospitalTypeId === 2 && job.altWeeklyPayHigh > 0 && !isLocumsEmploymentType$.value">
                                <strong class="nova__label flex-40"></strong>
                                <span class="flex-60">
                                    <ng-container *ngIf="job.altWeeklyPayLow === 0 && job.altWeeklyPayHigh > 0">
                                        Up to {{ job.altWeeklyPayHigh | currency }}
                                    </ng-container>
                                    <ng-container
                                        *ngIf="job.altWeeklyPayLow && job.altWeeklyPayLow > 0 && job.altWeeklyPayLow !== job.altWeeklyPayHigh">
                                        {{ job.altWeeklyPayLow | currency }} to {{
                                        job.altWeeklyPayHigh | currency }}
                                    </ng-container>
                                    <ng-container
                                        *ngIf="job.altWeeklyPayLow && job.altWeeklyPayLow > 0 && job.altWeeklyPayLow === job.altWeeklyPayHigh">
                                        {{ job.altWeeklyPayLow | currency }}
                                    </ng-container>
                                    <span class="flex-60" data-qa-id="an_rjd_altshifttype_readonly">{{ job.altShiftType
                                        }}</span>
                                </span>

                                <ng-container *ngTemplateOutlet="externalPayInfo"></ng-container>

                            </div>

                            <ng-template #externalPayInfo>
                                <span
                                    *ngIf="!displayConfigData?.hidePayFormat && (displayConfigData?.payRate !== '' && displayConfigData?.payRate !== null)"
                                    class="externalValue">
                                    (Displays as "{{payFormat}}")
                                </span>
                            </ng-template>


                            <div class="row-margin col-item flex-row" *ngIf="whatsThis">
                                <strong class="nova__label flex-40"></strong>
                                <span class="flex-60">
                                    <div class="info-box">
                                        <div class="flex-5">
                                            <em class="fa fa-info-circle"></em>
                                        </div>
                                        <small>
                                            <div
                                                *ngIf="job.weeklyPayLow && job.weeklyPayLow > 0 && job.weeklyPayLow !== job.weeklyPayHigh">
                                                <div>
                                                    <strong>Lowest</strong> = weekly pay + $1,000
                                                    relocation + insurance. <strong>Highest</strong> =
                                                    weekly pay (no benefits).
                                                </div>
                                                <div>
                                                    This range is visible to verified candidates in MyAya.
                                                    <a (click)="whatsThis = false;" href="javascript:void(0);"
                                                        class="small">hide</a>
                                                </div>
                                            </div>
                                            <div
                                                *ngIf="job.weeklyPayLow && job.weeklyPayLow > 0 && job.weeklyPayLow === job.weeklyPayHigh">
                                                <div>
                                                    <strong>Total weekly pay</strong> = weekly pay +
                                                    $1,000 relocation + insurance.
                                                </div>
                                                <div>
                                                    This pay is visible to verified candidates in MyAya.
                                                    <a (click)="whatsThis = false;" href="javascript:void(0);"
                                                        class="small">hide</a>
                                                </div>
                                            </div>
                                        </small>
                                    </div>
                                </span>
                            </div>

                            <ng-container *ngIf="!isLocumsEmploymentType$.value">
                                <div class="row-margin col-item flex-row">
                                    <strong class="nova__label flex-40">Facility Bonus:</strong>
                                    <span class="flex-60">{{ job.bonus | currency }}</span>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="showAyaPaidBonus">
                                <div class="row-margin col-item flex-row">
                                    <strong class="nova__label flex-40">Aya Paid Bonus:</strong>
                                    <span class="flex-60" data-qa-id="an_rjd_ayapaidbonus_readonly">{{ job?.ayaPaidBonus | currency }}</span>
                                </div>
                            </ng-container>

                            <div class="row-margin col-item flex-row">
                                <strong class="nova__label flex-40">Open Positions:</strong>
                                <span class="flex-60">{{ job.openPositions }}</span>
                            </div>
                            <div class="row-margin col-item flex-row">
                                <strong class="flex-40 nova__label">Facility:</strong>
                                <span class="flex-60" data-qa-id="an_rjd_facility_readonly">
                                    <a class="nova__link" target="_blank"
                                        [routerLink]="'/recruiting/facilities/' + job.facilityId">
                                        {{ job.facilityName }}
                                    </a>
                                    <a [href]="job.facilityWebsite">Website</a>
                                </span>
                                <span class="externalValue"
                                    *ngIf="!displayConfigData?.hideFacilityName && (displayConfigData?.facilityName !== '' && displayConfigData?.facilityName !== null)">
                                    (displays as "{{ displayConfigData?.facilityName }}")
                                </span>
                            </div>

                            <div class="row-margin col-item flex-row">
                                <strong class="flex-40 nova__label">Address:</strong>
                                <span class="flex-60" data-qa-id="an_rjd_facilityaddress_readonly">
                                    {{ job.facilityAddress }}
                                </span>
                            </div>

                            <div class="row-margin col-item flex-row">
                                <strong class="flex-40 nova__label">&nbsp;</strong>
                                <span class="flex-60" data-qa-id="an_rjd_facilitycitystate_readonly">
                                    {{ job.city }}, {{ job.stateName }}
                                </span>
                                <span class="externalValue" *ngIf="displayConfigData?.hideLocationName">
                                    (hidden externally)
                                </span>
                                <span class="externalValue"
                                    *ngIf="!displayConfigData?.hideLocationName && (displayConfigData?.locationName !== '' && displayConfigData?.locationName !== null)">
                                    (displays as "{{ displayConfigData?.locationName }}")
                                </span>
                            </div>

                            <div class="row-margin col-item flex-row">
                                <strong class="flex-40 nova__label">&nbsp;</strong>
                                <span class="flex-60">
                                    <div [hidden]="showMap" class="nova__link" (click)="showMap = !showMap"
                                        style="cursor: pointer">
                                        Show on Map
                                    </div>
                                </span>
                                <iframe *ngIf="job.googlemapssearcher && showMap" #frm title="map"
                                    style="border: 0; width: 100%; height: 500px"
                                    [src]="job.googlemapssearcher | safedom: 'resourceUrl'"></iframe>
                            </div>

                            <div class="row-margin col-item flex-row">
                                <strong class="flex-40 nova__label">VMS Provider:</strong>
                                <span class="flex-60" data-qa-id="an_rjd_vmsprovider_readonly">
                                    {{ job.vmsProvider }}
                                </span>
                            </div>

                            <div class="row-margin col-item flex-row">
                                <strong class="flex-40 nova__label">Account Manager:</strong>
                                <span class="flex-60" data-qa-id="an_rjd_accountmanager_readonly">
                                    <a class="a-blue" href="mailto:{{ job.accountManagerEmail }}">
                                        {{ job.accountManagerName }}
                                    </a>
                                </span>
                            </div>

                            <div class="row-margin col-item flex-row">
                                <strong class="flex-40 nova__label">Facility Classification:</strong>
                                <span class="text-body flex-60" data-qa-id="an_rjd_facilityrating_readonly">
                                    <nova-job-rating [dataItem]="job"></nova-job-rating>
                                </span>
                            </div>

                            <div class="row-margin col-item flex-row" *ngIf="job.isBlockSchedule">
                                <strong class="flex-0 nova__label">Eligible for Block Schedules</strong>
                            </div>

                            <div class="row-margin col-item flex-row">
                                <strong class="flex-40 nova__label">Number of beds:</strong>
                                <span class="flex-60" data-qa-id="an_rjd_numberbeds_readonly">
                                    {{ job.numberOfBeds }}
                                </span>
                            </div>

                            <ng-container *ngIf="isLocumsEmploymentType$ | async">
                                <div class="row-margin col-item flex-row">
                                    <strong class="flex-40 nova__label">Coverage Type:</strong>
                                    <span class="flex-60" data-qa-id="an_rjd_cd_readonly">
                                        {{ job.coverageTypeName }}
                                    </span>
                                </div>

                                <div class="row-margin col-item flex-row">
                                    <strong class="flex-40 nova__label">Shift Description:</strong>
                                    <span class="flex-60" data-qa-id="an_rjd_std_readonly">
                                        {{ job.shiftTypeDescription }}
                                    </span>
                                </div>
                            </ng-container>

                            <div class="row-margin col-item flex-row">
                                <strong class="flex-40 nova__label">Shift:</strong>
                                <span class="flex-60" data-qa-id="an_rjd_shift_readonly">
                                    {{ !isNovaCorehireAmJobsDetailsUpdatesEnabled || !showShiftTBD ? job.shiftDescription : 'TBD' }}
                                </span>
                                <span class="externalValue"
                                    *ngIf="displayConfigData?.hideShiftNote && !displayConfigData?.hideDetails">
                                    (hidden externally)
                                </span>
                                <span class="externalValue"
                                    *ngIf="!displayConfigData?.hideShiftNote && (displayConfigData?.shiftNote !== '' && displayConfigData?.shiftNote !== null)">
                                    (displays with note: "{{ displayConfigData?.shiftNote }}")
                                </span>
                            </div>

                            <ng-container *ngIf="!isNovaCorehireAmJobsDetailsUpdatesEnabled || showStartDate">
                                <div class="row-margin col-item flex-row">
                                    <strong class="flex-40 nova__label">Start Date:</strong>
                                    <span class="flex-60" data-qa-id="an_rjd_startdate_readonly">
                                        {{ job.startDate | date : "M/d/yyyy" : 'UTC' }}
                                    </span>
                                    <span class="externalValue" *ngIf="displayConfigData?.hideStartDate">
                                        (hidden externally)
                                    </span>
                                    <span class="externalValue" data-qa-id="an_rjd_dafault_start_date_info_text"
                                        *ngIf="isPermanentOrWorkforceDisruptionJob && displayConfigData?.startDate === null && displayConfigData?.hideStartDate === null">
                                        (displays as {{ startDate }})
                                    </span>
                                    <span class="externalValue"
                                        *ngIf="!displayConfigData?.hideStartDate && (displayConfigData?.startDate !== undefined && displayConfigData?.startDate !== null)">
                                        (displays as "{{ displayConfigData?.startDate }}")
                                    </span>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="!isNovaCorehireAmJobsDetailsUpdatesEnabled || !isPermanentEmploymentType">
                                <div class="row-margin col-item flex-row">
                                    <strong class="flex-40 nova__label">Duration (weeks):</strong>
                                    <span class="flex-60" data-qa-id="an_rjd_duration_readonly">
                                        {{ job.duration }}
                                        <span *ngIf="job.isJobDurationFlexible">
                                            (Flexible - see job description)
                                        </span>
                                    </span>
                                </div>
                            </ng-container>

                            <div class="row-margin col-item flex-row">
                                <strong class="flex-40 nova__label">Job Id:</strong>
                                <span class="flex-60" data-qa-id="an_rjd_jobid_readonly">
                                    {{ job.id }}
                                </span>
                            </div>

                            <ng-container *ngIf="isNovaCorehireAmJobsDetailsUpdatesEnabled && job.externalSourceJobId">
                                <div class="row-margin col-item flex-row">
                                    <strong class="flex-40 nova__label">External Job Id:</strong>
                                    <span class="flex-60" data-qa-id="an_rjd_externaljobid_readonly">
                                        {{ job.externalSourceJobId }}
                                    </span>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="isLocumsEmploymentType$ | async">
                                <div class="row-margin col-item flex-row">
                                    <strong class="flex-40 schedule-details-label nova__label">Schedule
                                        Details:</strong>
                                    <span class="flex-60" data-qa-id="an_rjd_sd_readonly">
                                        <span [innerHTML]="job.scheduleDetailsText"></span>
                                    </span>
                                </div>
                            </ng-container>

                            <div class="row-margin col-item flex-row externalValue">
                                <strong class="flex-40 nova__label"
                                    *ngIf="displayConfigData?.hideDetails || (!displayConfigData?.hideDetails && (displayConfigData?.details !== '' && displayConfigData?.details !== null))">
                                    Details:
                                </strong>
                                <span class="flex-60 externalValue" *ngIf="displayConfigData?.hideDetails">
                                    (hidden externally)
                                </span>
                                <span class="externalValue"
                                    *ngIf="!displayConfigData?.hideDetails && (displayConfigData?.details !== '' && displayConfigData?.details !== null)">
                                    (displays as: "<span [innerHTML]="displayConfigData?.details"></span>")
                                </span>
                            </div>
                        </div>
                    </mat-card>
                    <nova-job-unit-requirements *ngIf="showJobUnitRequirements"
                                                [data]="job.jobAndUnitRequirements"
                                                [jobId]="job.id"
                                                showUnitDetails="true">
                    </nova-job-unit-requirements>
                </div>
                <div class="flex-column flex-50">
                    <nova-job-unit-requirements *ngIf="showJobUnitRequirements"
                                                [data]="job.jobAndUnitRequirements"
                                                [jobId]="job.id"
                                                showJobRequirementsAndQualifications="true">
                    </nova-job-unit-requirements>

                    <mat-card>
                        <div layout-margin>
                            <div class="row-margin col-item flex-row" *ngIf="job.recipeFile">
                                <strong class="flex-40 nova__label"></strong>
                            </div>

                            <div class="row-margin col-item flex-row"
                                *ngIf="job.programTypeId !== null && job.programTypeId !== 5">
                                <strong class="flex-40 nova__label">Interview Type:</strong>
                                <span flex class="flex-60"
                                    data-qa-id="an_rjd_interviewtype_readonly">{{job.programTypeName}}</span>
                            </div>

                            <div class="row-margin col-item flex-row">
                                <strong class="flex-40 nova__label">Description:</strong>
                                <span flex class="flex-60" data-qa-id="an_rjd_description_readonly"
                                    [innerHtml]="job.description | textFormat"></span>
                            </div>

                            <ng-container *ngIf="!isNovaCorehireAmJobsDetailsUpdatesEnabled || !isPermanentEmploymentType">
                                <div class="row-margin col-item flex-row">
                                    <strong class="flex-40 nova__label">Submit Info:</strong>
                                    <span flex class="flex-60 text-body" [innerHtml]="job.submitInfo"></span>
                                </div>
                            </ng-container>

                            <div class="row-margin col-item flex-row">
                                <strong class="flex-40 nova__label">Special Instructions:</strong>
                                <span flex class="flex-60 text-body" data-qa-id="an_rjd_specialinstructions_readonly"
                                    [innerHtml]="job.additionalNotes"></span>
                            </div>

                            <ng-container *ngIf="!isNovaCorehireAmJobsDetailsUpdatesEnabled || !isPermanentEmploymentType">
                                <div class="row-margin col-item flex-row">
                                    <strong class="flex-40 nova__label">Computer Charting:</strong>
                                    <span flex class="flex-60 text-body"
                                        data-qa-id="an_rjd_computercharting_readonly">{{job.cSystem}}</span>
                                </div>

                                <div class="row-margin col-item flex-row">
                                    <strong class="flex-40 nova__label"></strong>
                                    <span flex class="flex-60 text-body">
                                        <div style="display: inline-block" [matTooltip]="newMarginCalcTooltip()">
                                            <button mat-button [disabled]="disableNewMarginCalc()"
                                                data-qa-id="an_rjd_newmargin_button"
                                                *ngIf="showNewMarginCalculator && isUserAllowedMargin"
                                                (click)="createNewMargin(job.id)" style="float: right">
                                                <img src="assets/images/svg/calculator.svg" alt="calculate" />
                                                Create New MC
                                            </button>
                                        </div>

                                        <button mat-button data-qa-id="an_rjd_linkmargin_button"
                                            (click)="linkMargin(job.id)" style="float: right" alt="calculate"
                                            *ngIf="showSampleMargin">
                                            <img src="assets/images/svg/calculator.svg" alt="calculate" />
                                            Link Margin
                                        </button>
                                        <button mat-button data-qa-id="an_rjd_samplemargin_button"
                                            (click)="sampleMargin(id, job.sampleMarginId)" style="float: right"
                                            *ngIf="job.sampleMarginId">
                                            <img src="assets/images/svg/calculator.svg" alt="calculate" />
                                            Sample Margin
                                        </button>

                                        <nova-atm-button [jobId]="job.id" style="float: right"></nova-atm-button>
                                    </span>
                                </div>
                            </ng-container>
                        </div>
                    </mat-card>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #nullNa>{{ null | nullNa }}</ng-template>
